import React from 'react';
import { Modal, Button } from 'antd';
import moment from 'moment';

import { _success, _setAxios } from '../../../lib/Helper';

class Restore extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false
        };
    }

    componentDidMount() {
        this.setState({
            values: {
                tgl_keluar: moment().format("MM/DD/YYYY"),
            },
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        });
        _setAxios("siswa/aktif/" + this.props.data.id, "PUT").then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {
      
        return (
            <Modal
                maskClosable={false}
                title={"Aktifkan data peserta didik"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Simpan</Button>
                </>}
            >
                Data siswa akan kembali diaktifkan & keterangan status keluar akan dihapus dari data ini, Apakah Anda Yakin ?
            </Modal>
        )
    }
}

export default Restore;
